'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_BACK_NAVIGATION = exports.SET_DRAWER_ITEMS = exports.SET_DRAWER_HEADER = exports.SET_DRAWER_MENU = exports.SET_APP_BAR = exports.SET_DRAWER = undefined;
exports.onClick = onClick;
exports.navigateBack = navigateBack;
exports.setDrawer = setDrawer;
exports.setBackNavigation = setBackNavigation;
exports.setAppBar = setAppBar;
exports.setMenu = setMenu;
exports.setHeader = setHeader;
exports.setItems = setItems;

var _reactRouterRedux = require('react-router-redux');

var SET_DRAWER = exports.SET_DRAWER = 'SET_DRAWER';
var SET_APP_BAR = exports.SET_APP_BAR = 'SET_APP_BAR';
var SET_DRAWER_MENU = exports.SET_DRAWER_MENU = 'SET_DRAWER_MENU';
var SET_DRAWER_HEADER = exports.SET_DRAWER_HEADER = 'SET_DRAWER_HEADER';
var SET_DRAWER_ITEMS = exports.SET_DRAWER_ITEMS = 'SET_DRAWER_ITEMS';
var SET_BACK_NAVIGATION = exports.SET_BACK_NAVIGATION = 'SET_BACK_NAVIGATION';

function onClick(route) {
  return (0, _reactRouterRedux.push)(route);
}

function navigateBack() {
  return (0, _reactRouterRedux.goBack)();
}

function setDrawer(drawer) {
  return {
    type: SET_DRAWER,
    payload: drawer
  };
}

function setBackNavigation(canNavigate) {
  return {
    type: SET_BACK_NAVIGATION,
    payload: canNavigate
  };
}

function setAppBar(appBar) {
  return {
    type: SET_APP_BAR,
    payload: appBar
  };
}

function setMenu(menu) {
  return {
    type: SET_DRAWER_MENU,
    payload: menu
  };
}

function setHeader(header) {
  return {
    type: SET_DRAWER_HEADER,
    payload: header
  };
}

function setItems(items) {
  return {
    type: SET_DRAWER_ITEMS,
    payload: items
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/DrawerMenuContainer/actions.js
 ** module id = 42
 ** module chunks = 0
 **/